export default __webpack_public_path__ + "static/media/lemons-leaves-no-shadow.ad574e8c.png";